import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogIn } from "lucide-react";

export default function AdminLoginPage() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="sb-card rounded-lg p-8 w-full max-w-sm sb-fade-up"
      >
        <h1 className="font-display text-2xl font-black mb-1">Admin Login</h1>
        <p className="text-xs mb-6" style={{ color: "var(--sb-text-muted)" }}>
          Stats Betting · Offerwall Control
        </p>

        <label className="block font-mono text-[10px] uppercase tracking-wider mb-2">Email</label>
        <input
          data-testid="login-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="sb-input mb-4"
          placeholder="admin@statsbetting.uk"
        />

        <label className="block font-mono text-[10px] uppercase tracking-wider mb-2">Password</label>
        <input
          data-testid="login-password"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="sb-input mb-5"
          placeholder="••••••••"
        />

        {err ? (
          <p data-testid="login-error" className="text-xs mb-3" style={{ color: "#FF6B61" }}>
            {err}
          </p>
        ) : null}

        <button
          data-testid="login-submit"
          disabled={busy}
          className="sb-btn-primary w-full py-3 text-sm uppercase tracking-wider inline-flex items-center justify-center gap-2"
        >
          <LogIn size={16} /> {busy ? "Signing in…" : "Sign In"}
        </button>
        <a
          href="/"
          className="block text-center text-[10px] font-mono uppercase tracking-wider mt-4 opacity-60 hover:opacity-100"
        >
          ← Back to site
        </a>
      </form>
    </div>
  );
}
